import * as React from 'react';

const ProjectFormErrorGlobal = ({ title, extraClass }) => (
	<div className={`error-message-form-container ${extraClass ? 'error-message-form-container--border' : ''}`}>
		{title}
	</div>
);

export default ProjectFormErrorGlobal;
